export const PASSWORD_ERROR = 'Passwords do not match';

export const initialStreamFormState = {
  userFile: '',
  artist: '',
	title: '',
	subtitle: '',
  link: '',
  startDate: '',
	endDate: '',
	ticketPrice: '',
	description: ''
};